import { styled } from "styled-components";

export const EventCellMobileCardWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: start;
  align-items: center;
  gap: 9rem;
`;